import React from 'react';

import Tab, { TabProps } from '@mui/material/Tab';

export const TngTab: React.FC<TabProps> = ({ ...tabProps }) => {
  return <Tab {...tabProps} />;
};
